module.exports = __webpack_public_path__ + "static/L5Y7s-08a491a307374ce0c4490e06bfb77894.jpg";